const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Recent Five directive to display a list of the 5 most recent Viewed, or Liked, or Shared contents, or Sessions etc
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Analyze the resource defined to get Analyze data
 * @argument {Resource} Overview the resource defined to get Overview view data
 * @argument {Resource} Users the resource defined to get Users view data
 */
app.directive('recentFive', ['Application', 'Analyze', 'Overview', 'Users', '$translate', function (Application, Analyze, Overview, Users, $translate) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        for : '@',
        of: '=?',
        text: '@'
      },
      template: require('../../../templates/directives/overview/recent-five.html'),
      controller: ['$scope', function ($scope) {
          var self = this;
          self.getError = Application.notifications.getError;
          self.getSuccess = Application.notifications.getSuccess;
          self.header = 'Header';
          self.icon = 'Icon';
          self.subresource = {};
          self.links = [];

          //translations
          $translate([
            'global.interactions.signins',
            'global.interactions.signups',
            'modules.recentFive.recent',
            'modules.recentFive.recentlyCreated',
            'modules.recentFive.recentlyCreatedContent' ,
            'modules.recentFive.recentlyModified',
            'modules.recentFive.recentlyModifiedContent',
            'modules.recentFive.recentlyViewed' ,
            'modules.recentFive.recentlyViewedContent' ,
            'modules.recentFive.recentlyLiked',
            'modules.recentFive.recentlyLikedContent' ,
            'modules.recentFive.recentlyShared' ,
            'modules.recentFive.recentlySharedContent'
          ]).then(function (data) {
            self.copy = data;
            self.initialize();
          });

          self.initialize = function () {

            self.subresource.subresource = $scope.for.toLowerCase();
            self.icon = self.subresource.subresource.slice(0, -1);
            switch (self.subresource.subresource) {
              case 'views':
                self.header = self.copy['modules.recentFive.recentlyViewed'] + ' ' + ($scope.of ? $scope.text : '');
                self.icon = 'view';
                break;
              case 'creations':
                self.header = self.copy['modules.recentFive.recentlyCreated'] + ' ' + ($scope.of ? $scope.text : '');
                break;
              case 'modifications':
                self.header = self.copy['modules.recentFive.recentlyModified'] + ' ' + ($scope.of ? $scope.text : '');
                break;
              case 'shares':
                self.header = self.copy['modules.recentFive.recentlyShared'] + ' ' + ($scope.of ? $scope.text : '');
                break;
              case 'likes':
                self.header = self.copy['modules.recentFive.recentlyLiked'] + ' ' + ($scope.of ? $scope.text : '');
                break;
              case 'signins':
                self.header = self.copy['modules.recentFive.recent']  + ' ' + self.copy['global.interactions.signins'];
                break;
              case 'signups':
                self.header = self.copy['modules.recentFive.recent']  + ' ' + self.copy['global.interactions.signups'];
                self.subresource.subresource = 'events';
                self.subresource.action = 'signup';
                break;
              default:
                console.log('Unknown for/subresource attribute ', $scope.for);
            }
            if ($scope.of) {
              var type = $scope.of.toLowerCase().slice(0, -1);
              if (type === 'quizze') {
                type = 'quiz';
              }
              if (type === 'conten') {
                type = 'content';
              }
              if (type === 'user') {
                Users.find({fields: 'first_name,last_name,email,createdAt', page: 1, per_page: 5, sort: 'createdAt,-1'}).$promise.then(function(data) {
                  angular.forEach(data, function(user) {
                    var link = {label: user.first_name + ' ' + user.last_name, link: '#/edit/users/' + user._id};
                    self.links.push(link);
                  });
                });
                return;
              }
              self.subresource.type = type;
              self.subresource.content_type = type;
            }

            Analyze.recent5(self.subresource, function (unresolved_items) {
              Overview.resolve({}, {unresolved: unresolved_items}, function (resolved_items) {
                angular.forEach(resolved_items, function (resolved_item) {
                  $translate('topfive.been_removed', { type : (resolved_item.content_type || resolved_item.type) }).then(function(translations){
                    var link = {label: (resolved_item.title || translations), link: '#/view/' + (resolved_item.content_type || resolved_item.type) + 's/' + resolved_item._id};
                    if ($scope.for === 'Signins' || $scope.for === 'Signups') {
                      link.link = '#/edit/users/' + resolved_item._id;
                    }
                    self.links.push(link);
                  });
                });
              }, function (error) {
                console.log('Error resolving items:', error);
                angular.forEach(unresolved_items, function (datum) {
                  $translate('topfive.been_removed', { type : (datum.content_type || datum.type) }).then(function(translations){
                    var link = {label: translations, link: '#/view/' + (datum.content_type || datum.type) + 's/' + datum._id};
                    self.links.push(link);
                  });
                });
              });
            }, function (error) {
              console.log('Error getting recent:', error);
            });
          };
          
        }],
      controllerAs: 'recent'
    };
  }]);
